import queryString from "query-string";

export const setSchedulingQueryStringData = () => state => {
  const { from } = queryString.parse(location.search);

  return {
    ...state,
    scheduling: {
      ...state.scheduling,
      from,
    },
  };
};
